<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Arbo4U/tc-custom/9781528967143.jpg?1705766068910" alt="This image is the cover for the book Why Oh Why Couldn't You Have Burnt The Bloody Place Down?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Oh Why Couldn't You Have Burnt The Bloody Place Down?
      </h1>
      <p class="bookDescription body article font2">
        <p>So after three and a half years you make it to Mons Officer Cadet School, including two years in a war, only to discover the terrorist who had tried to kill you with a grenade and who, you in return, had tried to shoot, ends up in the bed next to you! What do you do? Advice from the staff to check your bed for a grenade every night before you get into it doesn’t really help. Six months of brutality, tiredness, sleeplessness and absolute pressure follow with course attendees dropping like flies. A year at a boys’ regiment when he is persecuted for not burning down the Officers’ Club follows and his career ends at a tank depot where an insane ex-para has storemen and vehicle specialists pretending to be fit paras. And the final stress is to look after a full general who is a menace to wood and the main contributor to Elastoplast’s profit that year! Join our hero, Jack, in this the second of the trilogy and be ready for the third!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Huss
      </h2>
      
      <p class="authorDescription body article">Mike was born in London and raised happily in Surbiton. He left the grammar school at 18 and joined the regular army straight from school. He volunteered to serve in Aden (now Yemen) so as to join his fiancée who had already been posted there. She gave him the ring back on the night he got there and his subsequent adventures in a war for two years can be read in the first book in this trilogy, It must have been the compo. This, second book relates our hero Jack’s adventures for 6 months in a brutal training regime to become an officer following his recommendation for a commission in Aden. Subsequent service in the Depot (the now notorious Deepcut!), the Junior Leaders’ Regiment and a tank depot followed. A varied career with a N. Ireland Training Board, a group training association, as Personnel Director and Tribunal Advocate resulted in writing the Dear Doctor employment law column in the Sunday Times for 10 years. This is his second venture into fiction with a third in the trilogy to follow.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1e0b348